<template>  
   <drop @dragover="handleDragover(...arguments)" @drop="handleDrop">                      
    <v-tabs style="height:100%;display:flex;flex-direction:column;" v-model="selectedTab" align-with-title >              
      <fleet-detail-nav-tab class="fleetdetailtab"  v-for="tab in tabItems" :key="`${tab.cmp}-${tab.id}-${isleft}`" :tab="tab" :isleft="isleft" />
      <v-tab style="flex:0 0 auto" href="FleetMenu-0" class="fleetdetailmore" @click.stop.prevent="$store.myActions.FLEET_NAVTO_DETAIL({cmp:'FleetMenu',isleft, id:0})" :title="$t('Pilot.FleetInfos.AddDetailTabTooltip')">
        <v-icon>mdi-plus</v-icon>
      </v-tab>                      
      <v-tabs-items style="flex:1 1 auto;display:flex;" v-model="selectedTab">
          <v-tab-item  :reverse-transition="false" :transition="false" :value="`${tab.cmp}-${tab.id}`" v-for="tab in tabItems" :key="`${tab.cmp}-${tab.id}-${isleft}`">
            <component :is="tab.cmp" :isleft="isleft" :uiid="`${tab.cmp}-${tab.id}`" :fleet="currentDetailFleet.fleet" :isVisible="`${tab.cmp}-${tab.id}` == selectedTab"  />
          </v-tab-item>
          <v-tab-item :reverse-transition="false" :transition="false" value="FleetMenu-0"  >
            <fleet-menu :isleft="isleft" />        
          </v-tab-item>
      </v-tabs-items>                
    </v-tabs>  
  </drop>         
</template>
<script lang="ts">
  import Vue from 'vue'
  import Component from 'vue-class-component'      
  import FleetDetailNavTab from  '@/components/fleet/FleetDetailNavTab.vue'
  import FleetMenu from '@/components/fleet/FleetMenu.vue'    
  import { Watch} from 'vue-property-decorator'
  import FleetDetailMap from  '@/components/fleet/FleetDetailMap.vue'    
  import FleetDetailConsole from  '@/components/fleet/FleetDetailConsole.vue'
  import FleetDetailMissionPlan from  '@/components/fleet/FleetDetailMissionPlan.vue'
  import FleetDetailSmartControl from  '@/components/fleet/FleetDetailSmartControl.vue'  
  import FleetDetailParameter from  '@/components/fleet/FleetDetailParameter.vue'
  import FleetDetailParameterCoverage from  '@/components/fleet/FleetDetailParameterCoverage.vue'
  import FleetDetailParameterFormation from  '@/components/fleet/FleetDetailParameterFormation.vue'
  import FleetDetailLogBook from  '@/components/fleet/FleetDetailLogBook.vue'  
  import FleetDetailNextSurfacingDo from  '@/components/fleet/FleetDetailNextSurfacingDo.vue'
  import FleetDetailSendMail from  '@/components/fleet/FleetDetailSendMail.vue'
  import FleetDetailFileTransfer from  '@/components/fleet/FleetDetailFileTransfer.vue'
  import FleetDetailFtpRsync from  '@/components/fleet/FleetDetailFtpRsync.vue'
  import FleetDetailScienceGraphics from  '@/components/fleet/FleetDetailScienceGraphics.vue'
  import FleetDetailScienceGraphicsList from  '@/components/fleet/FleetDetailScienceGraphicsList.vue'
  import FleetDetailNavigationGraphics from  '@/components/fleet/FleetDetailNavigationGraphics.vue'
  import FleetDetailNavigationGraphicsList from  '@/components/fleet/FleetDetailNavigationGraphicsList.vue'  
  import FleetDetailImage from  '@/components/fleet/FleetDetailImage.vue'
  
   
    
  @Component({
    name: 'FleetDetail',
      components:{FleetDetailNavTab,FleetMenu,FleetDetailMap,FleetDetailConsole,FleetDetailMissionPlan,FleetDetailSmartControl,FleetDetailParameter,FleetDetailParameterCoverage,FleetDetailParameterFormation,FleetDetailNextSurfacingDo,FleetDetailLogBook,FleetDetailSendMail,FleetDetailFileTransfer,FleetDetailFtpRsync,FleetDetailScienceGraphics,FleetDetailScienceGraphicsList,FleetDetailNavigationGraphics,FleetDetailNavigationGraphicsList,FleetDetailImage},
      props: {
        isleft:Boolean
      }
  })
  export default class FleetDetail extends Vue {   
   
    isleft!:boolean
    selectedTab:any = null
    editedTabs:any = {}
   
    mounted() {
        this.selectedTab = this.selectedUiid
    }

    get currentDetailFleet(){
      return this.$store.myGetters.currentDetailFleet
    }
    get tabs() {
      return this.isleft?this.currentDetailFleet.tabsleft:this.currentDetailFleet.tabsright
    }
    get tabItems() {
      return this.tabs.tabs
    }
    get selectedUiid() {
      return this.tabs.selected
    }

    @Watch('selectedUiid')
    onSelectedUiidChanged(newValue: string, oldVaue: string) {      
        this.$nextTick(() => {               
          this.selectedTab = newValue                   
          this.$store.myActions.UI_REFRESH_COMPONENT(newValue)
        })
    }

    handleDragover(data:any, event:any) {
      if (data && ( !data.cmp || this.isleft == data.isleft)) {
        event.dataTransfer.dropEffect = 'none';
      }
    }
    
    handleDrop(data:any) {    
      if (data) {
        this.$store.myActions.FLEET_MOVE_TAB(data)
      }
    }    
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .v-tabs{
    border-bottom:1px solid #efefef;
  }
  .fleetdetailtab, .fleetdetailmore{
    border-right:1px solid #efefef;
  }
  .fleetdetailtab  .v-tabs__item{
    padding-right: 0;
  }
  .v-tabs__content{
    display:flex;
  }
  
</style>
